import timeOffInputStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TIMEOFF_REASON_ID', function setTimeOffReasonIdInStore(timeOffReasonId: string) {
    timeOffInputStore.timeOffReasonId = timeOffReasonId;
});
